module.exports = __webpack_public_path__ + "static/20200804_154651-a9e66c3f3e8457c7f55287436cf2202a.jpg";